module.exports = __webpack_public_path__ + "static/images/teaching_server_bg.4b27231.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newPromotionImg/teaching_server_bg.png
// module id = 4XF+
// module chunks = 11